// extracted by mini-css-extract-plugin
module.exports = {"tabList":"ProjectsTabs_tabList__1cI_D react-tabs__tab-list"};